import { useSyncExternalStore } from 'react';

/**
 * Sottoscrizione a una media query CSS.
 *
 * Serve dove il breakpoint cambia la *struttura* e non solo lo stile: sotto i
 * 900 px la sidebar diventa l'header orizzontale e il menu utente va spostato
 * lì dentro, che è un'altra sottoparte del DOM e non si raggiunge in CSS.
 * Renderizzarlo due volte e spegnerne uno con `display: none` lascerebbe due
 * dropdown montati con stato separato: meglio un solo nodo che cambia posto.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    // In SSR non esiste viewport: si assume desktop, come il CSS di base.
    () => false,
  );
}

/** Soglia unica del progetto: la stessa delle `@media` del v40. */
export const MOBILE_QUERY = '(max-width: 900px)';
